"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidAdjustment = void 0;
var isValidAction_1 = require("./isValidAction");
var isValidCriterion_1 = require("./isValidCriterion");
var isValidAdjustment = function (assetTypeAdjustment, assetTypeDefinitions) {
    if (assetTypeAdjustment === undefined) {
        return false;
    }
    if (!assetTypeAdjustment.criteria.every(function (crit) {
        return (0, isValidCriterion_1.isValidCriterion)(crit, assetTypeDefinitions);
    })) {
        return false;
    }
    if (!assetTypeAdjustment.actions.every(function (act) {
        return (0, isValidAction_1.isValidAction)(act, assetTypeDefinitions);
    })) {
        return false;
    }
    return true;
};
exports.isValidAdjustment = isValidAdjustment;
//# sourceMappingURL=isValidAdjustment.js.map